import { AnswersInitConfig } from "../types"

export const defaultAnswersConfig: Partial<AnswersInitConfig> = {
    locale: "en",
    experienceKey: "answers-starter",
    experienceVersion: "PRODUCTION",
}